import { useCallback } from 'react';
import { useAsync } from './useAsync';
import { listAssets, getAsset } from '@/services/assets';
import type { Asset } from '@/types/api';

export function useAssets(limit = 50) {
  const fn = useCallback(() => listAssets({ limit }).then((page) => page.items), [limit]);
  const { data, loading, error, refetch, setData } = useAsync<Asset[]>(fn);

  const prependAsset = useCallback(
    (asset: Asset) => {
      setData((prev) => {
        const list = prev ?? [];
        return [asset, ...list.filter((a) => a.id !== asset.id)];
      });
    },
    [setData],
  );

  return { data, loading, error, refetch, prependAsset };
}

export function useAsset(id: number | null) {
  const fn = useCallback(
    () => (id != null ? getAsset(id) : Promise.reject(new Error('No ID'))),
    [id],
  );
  return useAsync<Asset>(id != null ? fn : null);
}
